/**
* @constructor
* Detect when elements are in the viewport
*
* @param {selector} The elements we want to observe
* @param {$threshold} Soit un nombre, soit un tableau de nombre qui indique à quel pourcentage
* de la visibilité de la cible la fonction callback de la cible doit être exécuté.
* @param {once} If true, the state is defined once (doesn't go back to hidden when the element leave the viewport)
*/

export default function IsInView(selector, $threshold = 0.25, once = true) {
	const elements = document.querySelectorAll(selector);

	const observer = new IntersectionObserver(
		(changes) => {
			let timeout = 0;

			changes.forEach((change) => {
				if (change.isIntersecting === true) {
					timeout += 100;
					setTimeout(() => {
						change.target.setAttribute('data-state', 'visible');
					}, timeout);
				} else if (change.isIntersecting !== true && once !== true) {
					change.target.setAttribute('data-state', 'hidden');
				}
			});
		},
		{
			root: null,
			rootMargin: '0px',
			threshold: $threshold,
		},
	);

	this.init = () => {
		elements.forEach((element) => {
			element.setAttribute('data-state', 'hidden');
			observer.observe(element);
		});
	};
}
